// USER TYPES
export const FREE_USER_TYPE = 'Free';
export const CCPP_USER_TYPE = 'CCPP';
export const ET_ALL_APPS_USER_TYPE = 'ETAllApps';
export const ALL_APPS_USER_TYPE = 'AllApps';
export const SINGLE_APP_USER_TYPE = 'SingleApp';
export const OTHER_USER_TYPE = 'Other';
